<template>
  <div v-if="exploreGroups.length" class="mt-6 mb-4">
    <div class="flex justify-between items-center mb-3">
      <h3 class="text-base font-semibold m-0">Meer groepen in de buurt</h3>
      <router-link
        :to="exploreLink"
        class="text-sm text-green-600"
        @click.native="onViewAllClick"
      >
        Bekijk alle groepen{{ city ? ` in ${city}` : '' }}
      </router-link>
    </div>
    <div class="d-flex flex-row">
      <group-item
        v-for="group in exploreGroups"
        :key="group.groupId"
        view="blocks"
        :name="group.name"
        :city="group.city"
        :member-count="group.memberCount"
        :image-url="group.imageUrl"
        @click.native="onPreviewGroupClick(group.groupId)"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GroupItem from '@/components/GroupItem'
import { GROUP_EXPLORE, GROUP_EXPLORE_RESET } from '@/store/actions/group'
import analytics from '@/utils/analytics'

export default {
  name: 'ExploreGroupsPreview',
  components: {
    GroupItem
  },
  props: {
    city: {
      type: String,
      required: false,
      default: ''
    },
    activity: {
      type: [Number, String],
      required: false,
      default: ''
    }
  },
  computed: {
    ...mapState({
      exploreGroups: (state) => state.group.explore.groups,
      exploreCount: (state) => state.group.explore.count
    }),
    exploreLink() {
      const params = new URLSearchParams()
      if (this.city) params.set('city', this.city)
      if (this.activity) params.set('activity', this.activity)
      const query = params.toString()
      return `/groups${query ? `?${query}` : ''}`
    }
  },
  watch: {
    city() {
      this.fetchGroups()
    },
    activity() {
      this.fetchGroups()
    }
  },
  created() {
    this.fetchGroups()
  },
  methods: {
    fetchGroups() {
      this.$store.commit(GROUP_EXPLORE_RESET)
      this.$store.dispatch(GROUP_EXPLORE, {
        skip: 0,
        limit: 3,
        city: this.city,
        activity: this.activity,
        withoutEventsOnly: true
      })
    },
    onPreviewGroupClick(groupId) {
      analytics.capture('groups_preview_group_clicked', { group_id: groupId })
      this.$router.push(`/groups/${groupId}`)
    },
    onViewAllClick() {
      analytics.capture('groups_preview_view_all_clicked', {
        city: this.city,
        activity: this.activity
      })
    }
  }
}
</script>
